import { environment } from 'src/environments/environment';
import { ApplicationActivityModel } from 'src/Models/applicationActivityModel';

export function ApplicationActivityStore(actionName, pageName, appActivity, dataId = 0, dataType = 0, actionUrl = '', stateName= '') {
  const modal = new ApplicationActivityModel();
  modal.actionName = actionName;
  modal.pageName = pageName;
  modal.userId = +sessionStorage.getItem('UserId') || 0;
  modal.dataId = dataId;
  modal.pageUrl = document.location.href;
  modal.ipAddress = sessionStorage.getItem('ipAddress');
  modal.dataType = dataType;
  modal.actionUrl = actionUrl;
  modal.stateName = stateName;
  appActivity.ApplicationActivityAdd(sessionStorage.getItem('tokenValue'), modal).subscribe(res => {
  });
}

const StringIsNumber = value => isNaN(Number(value)) === false;
export function EnumToArray(enumme) {
  const returnArray = [];
  let index = 1;
  Object.keys(enumme).forEach((element) => {
    if (!StringIsNumber(element)) {
      returnArray.push({ id: index, itemName: element });
      index++;
    }

  });
  return returnArray;
}

export const IpAddressAllow = environment.allowedIps;

export function CheckIpAddresAllow(ipAddress: string) {
  return IpAddressAllow.findIndex(x => x == ipAddress) > -1;
}
